import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Formik } from 'formik';
import { useTranslation } from '@yoweb/next-i18next';
import { Grid } from '@yoweb/ui/components/Grid';
import { Textarea } from '@yoweb/ui/components/form';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { Title } from '@yoweb/ui/components/typography/Title';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { markTaskStillOpen } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { ActionModalFooter } from '@poplar/components/ActionModal/ActionModalFooter';
import { STANDARD_INPUT_MAX_LENGTH } from '@poplar/constants/app';
import { FlyoutContent, FlyoutContentContainer, StepHeader, StepGrid } from './Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NeedsWorkStep = function NeedsWorkStep(_ref) {
  var taskFeedback = _ref.taskFeedback,
      onSubmitted = _ref.onSubmitted;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useToast = useToast(),
      showToastError = _useToast.showToastError;

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: {
      feedback: ''
    },
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return markTaskStillOpen(taskFeedback.taskId, payload.feedback);

              case 2:
                response = _context.sent;

                if (response.status === ApiResponseStatus.ERROR) {
                  showToastError();
                } else {
                  onSubmitted();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    children: function children(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
          isSubmitting = _ref3.isSubmitting;
      return /*#__PURE__*/_jsxs(FlyoutContentContainer, {
        "data-testid": "needs-work-step",
        children: [/*#__PURE__*/_jsx(FlyoutContent, {
          children: /*#__PURE__*/_jsxs(StepGrid, {
            children: [/*#__PURE__*/_jsx(StepHeader, {
              taskFeedback: taskFeedback
            }), /*#__PURE__*/_jsxs(Grid, {
              gap: "normal3",
              children: [/*#__PURE__*/_jsx(Grid, {
                justifyItems: "left",
                children: /*#__PURE__*/_jsx(Title, {
                  size: "sm",
                  as: "h3",
                  textAlign: "center",
                  children: t('todo-feedback.how-can-we-help-finish')
                })
              }), /*#__PURE__*/_jsx(Textarea, {
                id: "feedback",
                name: "feedback",
                label: t('todo-feedback.how-can-we-help-finish-placeholder'),
                "data-testid": "todo-needs-feedback-textarea",
                maxLength: STANDARD_INPUT_MAX_LENGTH,
                maxHeight: 300,
                rows: 5
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(ActionModalFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            size: "lg",
            type: "submit",
            isLoading: isSubmitting,
            "data-testid": "needs-work-submit-button",
            onClick: function onClick() {
              return handleSubmit();
            },
            isFullWidth: true,
            children: t('actions.submit', {
              ns: 'common'
            })
          })
        })]
      });
    }
  });
};